<template>
  <page-list
    :list="list"
    :columns="columns"
    :single-actions="singleActions"
    :group-actions="groupActions" />
</template>

<script>
import * as R from 'ramda'
import ColumnsMixin from '../mixins/columns'
import SingleActionsMixin from '../mixins/singleActions'
import { getBrandFilter } from '@/utils/common/tableFilter'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'

export default {
  name: 'SKUOriginalList',
  mixins: [WindowsMixin, ListMixin, ColumnsMixin, SingleActionsMixin],
  props: {
    id: String,
    getParams: {
      type: [Function, Object],
    },
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'billing_sku_maps',
        getParams: this.getParam,
        filterOptions: {
          name: {
            label: 'SKU',
            filter: true,
            formatter: val => {
              return `name.contains("${val}")`
            },
          },
          id: {
            label: 'SKU_ID',
            filter: true,
            formatter: val => {
              return `id.contains("${val}")`
            },
          },
          provider: getBrandFilter(),
          service: {
            label: this.$t('op_14'),
          },
          sku_name: {
            label: this.$t('op_15'),
          },
          related: {
            label: this.$t('op_16'),
            dropdown: true,
            items: [
              { label: this.$t('op_17'), key: true },
              { label: this.$t('op_18'), key: false },
            ],
          },
        },
      }),
      groupActions: [
        {
          label: this.$t('op_19'),
          action: () => {
            this.createDialog('TemplateImportDialog', {
              title: this.$t('op_20'),
              onManager: this.onManager,
              refresh: this.refresh,
            })
          },
          meta: () => {
            return {
              buttonType: 'primary',
            }
          },
        },
        {
          label: this.$t('op_21'),
          action: () => {
            this.createDialog('SetLocalSKUDialog', {
              title: this.$t('op_21'),
              data: this.list.selectedItems,
              columns: this.columns,
              onManager: this.onManager,
              refresh: this.refresh,
            })
          },
          meta: () => {
            const selectedItems = this.list.selectedItems
            return {
              validate: selectedItems.length > 0 && selectedItems.filter(item => { return item.service !== selectedItems[0].service }).length === 0,
              buttonType: 'primary',
            }
          },
        },
      ],
    }
  },
  created () {
    this.list.fetchData()
  },
  methods: {
    getParam () {
      const ret = {
        ...(R.is(Function, this.getParams) ? this.getParams() : this.getParams),
      }
      return ret
    },
    handleOpenSidepage (row) {
      this.sidePageTriggerHandle(this, 'SKUOriginalSidePage', {
        id: row.id,
        resource: 'billing_sku_maps',
        getParams: this.getParam,
      }, {
        list: this.list,
      })
    },
  },
}
</script>
